import React, { useEffect } from "react";
import Specializedclinics from "./Specializedclinics";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import Infobox from "../../About/Infobox";
import Qns from "../../Services/Qns";
import Contactform from "../../About/Contactform";
import { movetop } from "../../../fun";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { Helmet } from "react-helmet-async";

function Specialize() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Specializedclinics />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  const elemnt2: elem = {
    oneBody: <Qns />,
    twoBody: <Contactform />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestspecilitiesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestspecilitiesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield is a leading multi-speciality clinic offering expert medical care across a wide range of disciplines including internal medicine, pediatrics, orthopedics, cardiology, dermatology, ENT, gynecology, and more with experienced specialists and personalized treatment plans.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Multi-speciality medical consultations",
              "Preventive health screening",
              "Chronic disease management",
              "Diagnostic imaging and lab services",
              "Minor procedures and day care services",
              "Pharmacy and medication support",
              "Integrated specialist referrals",
            ],
            keywords: [
              "best specility clinic in Immadihalli",
              "best specility clinic in Whitefield",
              "best specility clinic in Bangalore",
              "best specility clinic in Kundalahalli",
              "best specility clinic in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>
      <Servicebanner name="Specialized Clinics" banner={"../photo/dd23.jpg"} />
      <Infobox />
      {/* <Doctorbox /> */}
      <div className="flex justify-center py-6">
        <div className="containerbox">
          <p className="mb-4">
            ELV Health Care Polyclinics in Bengaluru offer a wide range of
            medical services, ensuring that individuals receive the attention
            and care they need. From a day care center and minor OT facilities
            to a fully stocked pharmacy and primary care services, ELV Health
            Care aims to be a one-stop solution for various medical
            requirements. Specialized departments, including Internal Medicine,
            Orthopedics, Cardiology, and more, house dedicated professionals
            committed to delivering top-notch healthcare.
          </p>
          <p>
            Certainly! ELV Health Care Polyclinics offer an extensive range of
            specialized clinics, ensuring a comprehensive approach to addressing
            the diverse healthcare needs of individuals. Here are some of the
            dedicated clinics available at ELV Health Care Polyclinics:
          </p>
        </div>
      </div>
      <Divser elemnt={elemnt} />

      <div className="pt-10 pb-10">
        <Divider />
      </div>
      <Divser elemnt={elemnt2} />

      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Specialize;
